'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002426 from "./presto.-Agent-View$$anon$26.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024 from "./presto.types$proto$-Unsigned-File-Base64$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$25() {
  this.ay4 = null;
  this.axW = null;
  this.axX = false;
  this.ay5 = null;
  this.ay6 = false;
  this.ay9 = null;
  this.ay2 = null;
  this.ay3 = false;
  this.axY = null;
  this.axZ = false;
  this.ay0 = null;
  this.ay1 = false;
  this.ay7 = false;
  this.ay8 = false;
  this.ay4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ay9 = "UnsignedFileBase64";
}
export { $c_Lpresto_AgentView$$anon$25 as $c_Lpresto_AgentView$$anon$25 };
$p = $c_Lpresto_AgentView$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$25;
/** @constructor */
function $h_Lpresto_AgentView$$anon$25() {
}
export { $h_Lpresto_AgentView$$anon$25 as $h_Lpresto_AgentView$$anon$25 };
$h_Lpresto_AgentView$$anon$25.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.ay4;
});
$p.L = (function() {
  if ((!this.axX)) {
    this.axW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axX = true;
  }
  return this.axW;
});
$p.O = (function() {
  if ((!this.ay6)) {
    this.ay5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ay6 = true;
  }
  return this.ay5;
});
$p.E = (function() {
  return this.ay9;
});
$p.t = (function() {
  if ((!this.ay3)) {
    this.ay2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ay3 = true;
  }
  return this.ay2;
});
$p.M = (function() {
  if ((!this.axZ)) {
    this.axY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2D(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().r2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axZ = true;
  }
  return this.axY;
});
$p.Q = (function() {
  if ((!this.ay1)) {
    this.ay0 = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002426.$c_Lpresto_AgentView$$anon$26();
    this.ay1 = true;
  }
  return this.ay0;
});
$p.w = (function() {
  if ((!this.ay8)) {
    this.ay7 = false;
    this.ay8 = true;
  }
  return this.ay7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee176) => ((p) => \u03b4scrutinee176.cH9(p)))($j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024.$m_Lpresto_types$proto$UnsignedFileBase64$())));
});
var $d_Lpresto_AgentView$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$25, "presto.AgentView$$anon$25", ({
  DP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$25 as $d_Lpresto_AgentView$$anon$25 };
//# sourceMappingURL=presto.-Agent-View$$anon$25.js.map
